import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

export default defineNuxtPlugin({
  name: 'bugsnag-init',
  dependsOn: ['pinia', 'mylhs-app'],
  setup() {
    const { vueApp, $app, $config, $pinia } = useNuxtApp();

    const bugsnag = Bugsnag.start({
      appVersion: $app.version,
      apiKey: $config.public.bugsnagApiKey,
      plugins: [new BugsnagPluginVue()],
      //otherOptions: value
    });

    const bugsnagVue = Bugsnag.getPlugin("vue");

    vueApp.use(bugsnagVue);

    const auth = useAuthStore($pinia);

    const gatherDebugData = (event) => {
      // Add additional diagnostic information
      event.addMetadata("user", {
        id: auth.user.id,
        username: auth.user.username,
      });
    };

    Bugsnag.addOnError(gatherDebugData);
    
    return {
      provide: {
        bugsnag
      }
    }
  },
  hooks: {
    // You can directly register Nuxt app runtime hooks here
    //'app:mounted'() {},
  }
})
